import { render, staticRenderFns } from "./ActSidebarCart.vue?vue&type=template&id=a880b6ba&scoped=true&"
import script from "./ActSidebarCart.vue?vue&type=script&lang=js&"
export * from "./ActSidebarCart.vue?vue&type=script&lang=js&"
import style0 from "./ActSidebarCart.vue?vue&type=style&index=0&id=a880b6ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a880b6ba",
  null
  
)

export default component.exports